import { render } from "./newInvoiceTwo.vue?vue&type=template&id=00d989d0"
import script from "./newInvoiceTwo.vue?vue&type=script&lang=js"
export * from "./newInvoiceTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__